// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"972835c7","455":"78d32aa2","977":"00f8075a"}[chunkId] + ".chunk.js";
};